import coreDownloadService, { DownloadContentType } from '@/core/download/coreDownload.service';
import gtmService from '@/project/tracking/gtm/GTM.service';

class DownloadService {
    downloadFile(file: Blob | string | object, fileName: string, contentType: DownloadContentType) {
        coreDownloadService.downloadFileCore(file, fileName, contentType);
        gtmService.trackLinkClick(fileName);
    }

    downloadImage(fileUrl: string, fileName: string) {
        coreDownloadService.downloadImageCore(fileUrl, fileName);
        gtmService.trackLinkClick(fileName);
    }
}

export {
    DownloadContentType
};

export default new DownloadService();
